import { useRecoilState } from 'recoil'

import { TimeOfBirthState } from '@/features/user/fortune/store'
import CheckBoxForm from '@/shared/components/common/CommonForm/CheckBoxForm'
import { TimeOfBirthItems } from '@/shared/constant'
import { ModalAlertContent, ModalDefaultTitle, ModalTimeOfBirth } from '@/styles/common/modal'

const TimeOfBirth = (props: any) => {
  const { ClickFunc } = props
  const [TimeOfBirthValue, setTimeOfBirthValue] = useRecoilState(TimeOfBirthState)
  return (
    <ModalAlertContent>
      <ModalDefaultTitle className={'time_of_birth'}>출생시간</ModalDefaultTitle>
      <ModalTimeOfBirth>
        <CheckBoxForm
          data={TimeOfBirthItems}
          checked={TimeOfBirthValue}
          onChange={setTimeOfBirthValue}
          onSuccess={ClickFunc}
        />
      </ModalTimeOfBirth>
    </ModalAlertContent>
  )
}
export default TimeOfBirth
